/**
 * Selector to toasts inside NotificationManager state domain
 */
export const selectOverlay = (state) => state.getIn(['toastManager', 'overlay']);

/**
 * Selector to toasts inside NotificationManager state domain
 */
export const selectToasts = (state) => state.getIn(['toastManager', 'toasts']).toJS();

export const getDownloadErrorReportsCount = (state) => state.getIn(['toastManager', 'downloadErrorReportsCount']);